import { Parcel, ParcelApi, ParcelCreateResult, ParcelCreateResultApi } from '../types';

export class ParcelMappers {
  public static oneFromApi(parcel: ParcelApi): Parcel {
    return {
      id: parcel.id,
      name: parcel.box,
      user: parcel.user_id ? { id: parcel.user_id, name: parcel.user_name || '' } : null,
      branch: parcel.branch_id && parcel.branch_name ? { id: parcel.branch_id, name: parcel.branch_name } : null,
      counts: { declarations: parcel.declaration_count },
      createdAt: parcel.created_at,
      countryId: parcel.country_id,
    };
  }

  public static manyFromApi(parcels: ParcelApi[]): Parcel[] {
    return parcels.map((parcel) => this.oneFromApi(parcel));
  }

  public static createResultFromApi(result: ParcelCreateResultApi): ParcelCreateResult {
    return {
      id: result,
    };
  }
}
